import { AnyAction } from 'redux';
import {
  GlobalActions,
  RoleDeterminedPayload,
  StreckenTarifierungRequestEvents,
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  BaseTransientState,
  FeatureToggles,
  Regexps,
  Rolle,
  VorvertragVorschaedenState,
} from '@ps20-frontend/frontend-models';
import { vorvertragVorschaedenErmitteltReducer } from '@ps20-frontend/reducers';
import { PhActions } from '../phActions';

export interface TransientState extends BaseTransientState, VorvertragVorschaedenState, Rolle {}

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
): TransientState {
  switch (action.type) {
    case PhActions.ZURUECK_ZUM_SHOP_MODAL_OPEN: {
      return { ...sectionState, zurueckZumShopModalOpen: true };
    }
    case PhActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE: {
      return { ...sectionState, zurueckZumShopModalOpen: false };
    }
    case GlobalActions.TARIFIERUNG_HAS_STARTED: {
      return { ...sectionState, tarifierungIsInProgress: true };
    }
    case GlobalActions.TARIFIERUNG_HAS_ENDED: {
      return { ...sectionState, tarifierungIsInProgress: false };
    }
    case StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_PH: {
      const payload = action.payload;
      if (payload.response?.data?.taasStatus) {
        return {
          ...sectionState,
          fehlerCodeTaas: payload.response.data.taasStatus.fehlerCode,
        };
      }
      return { ...sectionState, fehlerCodeTaas: null };
    }
    case GlobalActions.SET_PRICE_GUARANTEE: {
      return { ...sectionState, priceGuarantee: action.payload };
    }
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH: {
      return {
        ...sectionState,
        priceGuarantee: false,
      };
    }
    case GlobalActions.ROLE_DETERMINED: {
      const actionPayload: RoleDeterminedPayload = action.payload;
      return { ...sectionState, role: actionPayload.role };
    }
    case GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT: {
      return vorvertragVorschaedenErmitteltReducer(sectionState, action, {
        appId: App.PH,
      });
    }
    case GlobalActions.FEATURE_TOGGLE_RECEIVED: {
      const actionPayload: FeatureToggles = action.payload;
      return { ...sectionState, featureToggles: actionPayload };
    }
    case GlobalActions.REGEXPS_RECEIVED: {
      const actionPayload: Regexps = action.payload;
      return { ...sectionState, regexps: actionPayload };
    }
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    default:
      return sectionState;
  }
};
